export default __webpack_public_path__ + "static/media/box-arrow.9f0e908d.svg";